import ufeApi from 'services/api/ufeApi';
import urlUtils from 'utils/Url';

// https://jira.sephora.com/browse/CE-286

function getApiUrl(type) {
    const qsParams = { type };
    const urlParams = urlUtils.makeQueryString(qsParams);

    return `/gway/v1/notify/skus?${urlParams}`;
}

function getApiPayload(payload) {
    return { ...payload, notificationType: 'SMS' };
}

function backInStockSMSOptInForm(payload, type) {
    const url = getApiUrl(type);
    const apiPayload = getApiPayload(payload);
    const requestOrigin = 'OOSNotification';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ ...apiPayload, requestOrigin }),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default { backInStockSMSOptInForm };
